import { render } from "./ScrollingImageInFrame.vue?vue&type=template&id=ef8e3ac2&scoped=true"
import script from "./ScrollingImageInFrame.vue?vue&type=script&lang=js"
export * from "./ScrollingImageInFrame.vue?vue&type=script&lang=js"

import "./ScrollingImageInFrame.vue?vue&type=style&index=0&id=ef8e3ac2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef8e3ac2"]])

export default __exports__